import * as React from 'react';
import { SVGProps } from 'react';

const RectangleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={8}
    fill="none"
    {...props}
  >
    <path fill="#D9D9D9" d="M12 .5H0l6 7 6-7Z" />
  </svg>
);
export default React.memo(RectangleIcon);
